import { apiBaseUrl } from '../api/base-url.js'

function authHeaders(): Record<string, string> {
  const t = sessionStorage.getItem('portalToken')
  return t ? { authorization: `Bearer ${t}` } : {}
}

// Two-step upload against the portal endpoints (authorized by the portal
// session, not an upload token): presigned PUT → PUT to S3 → complete.
export async function uploadPortalDoc(
  requestId: number,
  file: File,
  completion: 'complete' | 'renew' = 'complete',
): Promise<void> {
  const base = apiBaseUrl()
  const urlRes = await fetch(`${base}/public/portal/requests/${requestId}/upload-url`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ contentType: file.type, sizeBytes: file.size }),
  })
  if (!urlRes.ok) throw new Error('upload_url_failed')
  const { url, objectKey } = (await urlRes.json()) as { url: string; objectKey: string }

  const put = await fetch(url, {
    method: 'PUT',
    headers: { 'content-type': file.type },
    body: file,
  })
  if (!put.ok) throw new Error('s3_put_failed')

  const done = await fetch(`${base}/public/portal/requests/${requestId}/${completion}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ objectKey, fileName: file.name, contentType: file.type }),
  })
  if (!done.ok) throw new Error(`${completion}_failed`)
}
